/**
 * PrintButton — calls window.print() on the host page.
 * Pair with the global @media print rules in App.css to hide nav/buttons.
 */
import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PrintButton({ label = 'Print / PDF', testid = 'print-pdf-btn', size = 'sm' }) {
  return (
    <Button
      variant="outline"
      size={size}
      onClick={() => window.print()}
      data-testid={testid}
      className="no-print"
    >
      <Printer className="h-3.5 w-3.5 mr-1.5" />
      {label}
    </Button>
  );
}
